import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
// styles
import {
  BulletedListStyled,
  ColStyled,
  LinkStyled,
  TypographyStyled,
} from '../styles';

const baseIdPrefix = 'sitemap-insurance';
const baseIdSuffix = 'link';

const bulletedListConfig = [
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-insurance-${baseIdSuffix}`}
        linkUrl='/insurance/'
        variant='primaryDeemphasize'>
        Insurance
      </Link>
    ),
  },
  {
    bulletText: (
      <>
        <LinkStyled
          id={`${baseIdPrefix}-life-insurance-${baseIdSuffix}`}
          linkUrl='/life-insurance/'
          variant='primaryDeemphasize'>
          Life Insurance
        </LinkStyled>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-whole-life-insurance-${baseIdSuffix}`}
                  linkUrl='/life-insurance/whole-life-insurance/'
                  variant='primaryDeemphasize'>
                  Whole Life Insurance
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-universal-life-insurance-${baseIdSuffix}`}
                  linkUrl='/life-insurance/universal-life-insurance/'
                  variant='primaryDeemphasize'>
                  Universal Life Insurance
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-variable-universal-life-insurance-${baseIdSuffix}`}
                  linkUrl='/life-insurance/variable-universal-life-insurance-vul/'
                  variant='primaryDeemphasize'>
                  Variable Universal Life Insurance
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-term-life-insurance-${baseIdSuffix}`}
                  linkUrl='/life-insurance/term-life-insurance/'
                  variant='primaryDeemphasize'>
                  Term Life Insurance
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-life-insurance-calculator-${baseIdSuffix}`}
                  linkUrl='/life-insurance/life-insurance-calculator/'
                  variant='primaryDeemphasize'>
                  Life Insurance Calculator
                </Link>
              ),
            },
          ]}
          bulletType='filledCircle'
        />
      </>
    ),
  },
  {
    bulletText: (
      <>
        <LinkStyled
          id={`${baseIdPrefix}-disability-insurance-${baseIdSuffix}`}
          linkUrl='/disability-insurance/'
          variant='primaryDeemphasize'>
          Disability Insurance
        </LinkStyled>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-disability-insurance-for-individuals-${baseIdSuffix}`}
                  linkUrl='/disability-insurance/'
                  variant='primaryDeemphasize'
                  ariaLabel='Disability Insurance for individuals'>
                  For Individuals
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-disability-insurance-for-physicians-and-dentists-${baseIdSuffix}`}
                  linkUrl='/disability-insurance/physicians-and-dentists-disability-insurance/'
                  variant='primaryDeemphasize'>
                  For Doctors and Dentists
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-disability-insurance-calculator-${baseIdSuffix}`}
                  linkUrl='/disability-insurance/disability-insurance-calculator/'
                  variant='primaryDeemphasize'>
                  Disability Insurance Calculator
                </Link>
              ),
            },
          ]}
          bulletType='filledCircle'
        />
      </>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-long-term-care-planning-${baseIdSuffix}`}
        linkUrl='/long-term-care-planning/'
        variant='primaryDeemphasize'>
        Long&#45;Term Care Planning
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-income-annuities-${baseIdSuffix}`}
        linkUrl='/annuities/'
        variant='primaryDeemphasize'>
        Income Annuities
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-life-insurance-overview-guide-${baseIdSuffix}`}
        linkUrl='/life-and-money/life-insurance-guide/'
        variant='primaryDeemphasize'>
        Life Insurance Overview Guide
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-convertible-term-life-insurance-${baseIdSuffix}`}
        linkUrl='/life-insurance/term-life-insurance/convertible-term-life-insurance/'
        variant='primaryDeemphasize'>
        Convertible Term Life Insurance
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-additional-purchase-benefits-${baseIdSuffix}`}
        linkUrl='/apb-info-center/'
        variant='primaryDeemphasize'>
        Additional Purchase Benefits
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-underlying-fund-information-and-statistics-${baseIdSuffix}`}
        linkUrl='/life-insurance/variable-universal-life-insurance-vul/underlying-fund-information/'
        variant='primaryDeemphasize'>
        Underlying Fund Information and Statistics
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-prospectuses-and-reports-${baseIdSuffix}`}
        linkUrl='/life-insurance/variable-universal-life-insurance-vul/underlying-fund-information/prospectuses-performance-and-reports/'
        variant='primaryDeemphasize'>
        Prospectus and Reports
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-nm-series-fund-income-${baseIdSuffix}`}
        linkUrl='https://connect.rightprospectus.com/NorthwesternMutual?site=Funds/'
        variant='primaryDeemphasize'
        isOutgoingLink>
        NM Series Fund Income
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-how-we-determine-dividends-${baseIdSuffix}`}
        linkUrl='/life-insurance/whole-life-insurance/dividend-paying-whole-life-insurance/'
        variant='primaryDeemphasize'>
        How We Determine Dividends
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-daily-unit-values-universal-life-insurance-${baseIdSuffix}`}
        linkUrl='/life-insurance/universal-life-insurance/daily-unit-values-universal-life-insurance/'
        variant='primaryDeemphasize'>
        Daily Unit Values &#8211; Universal Life Insurance
      </Link>
    ),
  },
];
export default () => (
  <ColStyled
    medium={6}
    id='sitemap-insurance-list'>
    <TypographyStyled
      component='h2'
      variant='h3'
      nextElement='typography'>
      Insurance
    </TypographyStyled>
    <BulletedListStyled
      bulletedListData={bulletedListConfig}
      bulletType='none'/>
  </ColStyled>
);
